module.exports = __webpack_public_path__ + "img/logo-placeholder.5cdd8b5b.svg";